import React from "react";

const SVG = ({
  style = {},
  fill = "#000",
  className = "", 
  width="23.851", 
  height="24.299", 
  viewBox="0 0 23.851 24.299"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path fill={fill}id="Path_26" d="M134.912 157.326a9.62 9.62 0 0 1-12.2-12.2 1.383 1.383 0 0 0-1.883-1.706 11.918 11.918 0 1 0 15.793 15.793 1.383 1.383 0 0 0-1.71-1.887z" className="cls-1" data-name="Path 26" transform="translate(-113.858 -141.876)"/>
    <path fill={fill} id="Path_27" d="M437.225 114.478l-1.937-.281a.859.859 0 0 1-.647-.47l-.866-1.755a.859.859 0 0 0-1.541 0l-.866 1.755a.859.859 0 0 1-.647.47l-1.937.281a.859.859 0 0 0-.476 1.466l1.4 1.366a.859.859 0 0 1 .247.761l-.329 1.929a.859.859 0 0 0 1.247.906l1.732-.911a.859.859 0 0 1 .8 0l1.732.911a.859.859 0 0 0 1.247-.906l-.331-1.929a.859.859 0 0 1 .247-.761l1.4-1.366a.859.859 0 0 0-.475-1.466z" className="cls-1" data-name="Path 27" transform="translate(-414.111 -111.492)"/>
  </svg>
);

export default SVG;



// WEBPACK FOOTER //
// ./src/components/UI/Icons/Moon.js